<div class="Content_outer" #divToScroll>
  <div class="content_view">
    <div class="row">
      <div class="col-md-12">
        <div class="newform_outer">
          <div class="filter_div">
            <div class="top">
              <h4>{{ showEditUsertxt }}</h4>
            </div>
          </div>
          <div class="both_side add_asset">
            <div class="left_side">
              <div class="inner">
                <div class="upload">
                  <img
                    src="{{ _imgUrl }}"
                    alt="User"
                    onerror="this.src='./assets/img-new/default_user.png'"
                  />
                  <div class="action_btn">
                    <div
                      class="upload-btn-wrapper"
                      *ngIf="showEditUsertxt === 'Create Asset'"
                    >
                      <button class="btn default_btn" mat-raised-button>
                        Upload Logo
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        ng2FileSelect
                        [uploader]="uploader"
                        (change)="upload($event.target.files)"
                      />
                    </div>

                    <div
                      class="upload-btn-wrapper"
                      *ngIf="showEditUsertxt === 'Edit Asset'"
                    >
                      <button class="btn default_btn" mat-raised-button>
                        Replace
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        ng2FileSelect
                        [uploader]="uploader"
                        (change)="upload($event.target.files)"
                      />
                    </div>
                    <button
                      [disabled]="pic == false"
                      *ngIf="showEditUsertxt === 'Edit Asset'"
                      class="btn default_btn"
                      mat-raised-button
                      (click)="removeUserImage($event.target.files)"
                    >
                      Remove
                    </button>
                  </div>
                  <div class="support">
                    <h5>Supported formats:<span>jpg, png, gif</span></h5>
                    <h5>Maximum Size:<span>500KB</span></h5>
                  </div>
                </div>
                <div
                  *ngIf="showEditUsertxt != 'Edit Asset'"
                  class="container"
                  style="padding-top: 46px"
                ></div>
                <!--condition for edit asset-->
                <div
                  *ngIf="showEditUsertxt == 'Edit Asset'"
                  class="container"
                  style="padding-top: 46px"
                ></div>
              </div>
            </div>
            <!------------------------FORM FOR ASSETS-------------------------->
            <div class="right_side">
              <div *ngIf="assetDetailForm">
                <form [formGroup]="uForm" (ngSubmit)="saveAsstes()">
                  <h4>
                    <button
                      [disabled]="true"
                      [style.background-color]="
                        currentLbl === 1 ? '#FFB3B3' : '#C4DFAA'
                      "
                    >
                      {{
                        showEditUsertxt ==
                        "Edit
                        Asset"
                          ? device_sno
                          : currentSensorIndex == 0
                          ? "B"
                          : currentSensorIndex
                      }}
                    </button>
                    {{ selectedAssetType }} Asset Details
                  </h4>
                  <div class="row">
                    <div class="col-md-6 col">
                      <label
                        >Asset Name *<span
                          class="material-icons info"
                          ngbPopover="Asset Name, given by the Client, e.g. Mixer Motor 1"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="name"
                        id="name"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.name"
                      ></control-messages>
                    </div>
                    <div class="col-md-6 col">
                      <label
                        >Site *<span
                          class="material-icons info"
                          ngbPopover="Client Site, e.g. Hamilton Site"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="showEditUsertxt == 'Edit Asset'"
                        type="text"
                        class="form-control"
                        formControlName="site_id_val"
                        id="site_id_val"
                      />
                      <span
                        class="custom_select_outer"
                        *ngIf="showEditUsertxt == 'Create Asset' || 'Update Powertrain'"
                      >
                        <select
                          class="custom_select form-control"
                          formControlName="site_id"
                          id="site_id"
                          (change)="selectSite($event.target.value)"
                        >
                          <option value="all"></option>
                          <option
                            [value]="site.id"
                            *ngFor="let site of sitesList"
                          >
                            {{ site.name }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Application *<span
                          class="material-icons info"
                          ngbPopover="Name of the Application, given by the Client, e.g. Scrubber Application"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="showEditUsertxt == 'Edit Asset'"
                        type="text"
                        class="form-control"
                        formControlName="application_id_name"
                        id="application_id_name"
                      />
                      <span
                        class="custom_select_outer"
                        *ngIf="showEditUsertxt == 'Create Asset' || 'Update Powertrain'"
                      >
                        <select
                          id="application_id"
                          class="custom_select form-control"
                          (change)="selectGroup($event.value)"
                          formControlName="application_id"
                        >
                          <option
                            *ngFor="
                              let application of applications;
                              let idx = index
                            "
                            [ngValue]="application.id"
                          >
                            {{ application.name }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-6"></div>
                  </div>

                  <hr class="horizontal_line" />

                  <div class="row">
                    <div class="col-md-6 col">
                      <label
                        >Line Current<span
                          class="material-icons info"
                          ngbPopover="Line Current"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="line_current"
                        id="line_current"
                      />
                    </div>
                    <div class="col-md-6 col">
                      <label
                        >Device Name *<span
                          class="material-icons info"
                          ngbPopover="Device identifiers"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="device_name"
                        id="device_name"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.device_name"
                      ></control-messages>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Device ID *<span
                          class="material-icons info"
                          ngbPopover="Enertics Device Serial Number"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <input
                          class="form-control"
                          type="text"
                          formControlName="mac_address"
                          id="mac_address"
                          (input)="filterUsers($event.target.value)"
                          [matAutocomplete]="auto4"
                        />
                        <mat-autocomplete
                          autoActiveFirstOption
                          #auto4="matAutocomplete"
                          (optionSelected)="
                            onFilterOptionSelected($event.option.value)
                          "
                        >
                          <mat-option
                            *ngFor="let option of filterdOptions"
                            [value]="option.mac_address"
                            (click)="selectedOption()"
                          >
                            {{ option.mac_address }}
                          </mat-option>
                        </mat-autocomplete>
                        <control-messages
                          class="err-msg"
                          [control]="uForm.controls.mac_address"
                        ></control-messages>
                      </span>
                      <p
                        style="
                          font-size: 12px;
                          color: #b10000;
                          margin-bottom: 0px;
                          margin-top: 0px;
                        "
                        *ngIf="ivInventoryMsg != ''"
                      >
                        {{ ivInventoryMsg }}
                      </p>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Motor Make<span
                          class="material-icons info"
                          ngbPopover="Manufacturer of the Motor"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="motor_make"
                        id="motor_make"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label>Equipment Location</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="equipment_location"
                        id="equipment_location"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Frame<span
                          class="material-icons info"
                          ngbPopover="The Frame Size of motor according to NEMA standard"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="frame"
                        id="frame"
                      />
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Rated Ambient Temperature<span
                          class="material-icons info"
                          ngbPopover="Maximum ambient temperature motor is designed to operate at, typically 40C"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          class="form-control"
                          type="number"
                          formControlName="rated_ambient_temprature"
                          id="rated_ambient_temprature"
                        />

                        <mat-radio-group
                          formControlName="temperature_sy"
                          id="temperature_sy"
                        >
                          <mat-radio-button value="C"> ̊C</mat-radio-button>
                          <mat-radio-button value="F">F</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Insulation Class *<span
                          class="material-icons info"
                          ngbPopover="The insulation class of motor (A/B/F/H) according to NEMA standard"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="insulation_class"
                          id="insulation_class"
                        >
                          <option *ngFor="let cla of insertClass" [value]="cla">
                            {{ cla }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Serial Number *<span
                          class="material-icons info"
                          ngbPopover="Serial Number on the Motor nameplate"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="motor_serial"
                        id="motor_serial"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.motor_serial"
                      ></control-messages>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Rated Power *<span
                          class="material-icons info"
                          ngbPopover="Power in KW or HP the motor was designed to operate at"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          type="text"
                          class="form-control"
                          type="number"
                          formControlName="rated_power"
                          id="rated_power"
                        />
                        <control-messages
                          class="err-msg"
                          [control]="uForm.controls.rated_power"
                        ></control-messages>
                        <mat-radio-group
                          aria-label="Select an option"
                          formControlName="power_unit"
                          id="power_unit"
                        >
                          <mat-radio-button value="KW">KW</mat-radio-button>
                          <mat-radio-button value="fi">HP</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Rated RPM *<span
                          class="material-icons info"
                          ngbPopover="Rated RPM the motor was designed to operate at"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          type="text"
                          class="form-control"
                          type="number"
                          formControlName="rated_rpm"
                          id="rated_rpm"
                        />
                        <control-messages
                          class="err-msg"
                          [control]="uForm.controls.rated_rpm"
                        ></control-messages>
                        <mat-radio-group
                          aria-label="Select an option"
                          formControlName="rpm_toggle"
                          id="rpm_toggle"
                          (change)="onRPMChange($event)"
                        >
                          <mat-radio-button value="fixed"
                            >Fixed</mat-radio-button
                          >
                          <mat-radio-button value="variable"
                            >Variable</mat-radio-button
                          >
                        </mat-radio-group>
                      </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="variableRPMToggle !== 'fixed'">
                    <div class="col col-md-6">
                      <label
                        >Min Rated RPM *<span
                          class="material-icons info"
                          ngbPopover="Min Rated RPM"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          style="margin-left: 5px"
                          type="text"
                          class="form-control"
                          type="number"
                          formControlName="min_rated_rpm"
                          id="min_rated_rpm"
                        />
                        <control-messages
                          class="err-msg"
                          [control]="uForm.controls.min_rated_rpm"
                        ></control-messages>
                      </div>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Max Rated RPM *<span
                          class="material-icons info"
                          ngbPopover="Max Rated RPM *"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          style="margin-left: 5px"
                          type="text"
                          class="form-control"
                          type="number"
                          formControlName="max_rated_rpm"
                          id="max_rated_rpm"
                        />
                        <control-messages
                          class="err-msg"
                          [control]="uForm.controls.max_rated_rpm"
                        ></control-messages>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Rated Voltage<span
                          class="material-icons info"
                          ngbPopover="Max Volatage the motor was designed to operate at"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="rated_voltage"
                        id="rated_voltage"
                      />
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Precentage Efficiency<span
                          class="material-icons info"
                          ngbPopover="% of Electrical Energy Converted to Mechanical Energy"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="percentage_efficiency"
                        id="percentage_efficiency"
                      />
                    </div>
                  </div>
                  <div class="row" *ngIf="subAssetType !== 'DC_MOTOR'">
                    <div class="col col-md-6">
                      <label
                        >Line Frequency *<span
                          class="material-icons info"
                          ngbPopover="Line Frequency of the incoming electrical supply to the motor"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="line_frequency"
                        id="line_frequency"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.line_frequency"
                      ></control-messages>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Power Factor<span
                          class="material-icons info"
                          ngbPopover="Ratio of real power generated to apparent power in the circuit, e.g. electric motor"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        type="number"
                        formControlName="power_factor"
                        id="power_factor"
                      />
                    </div>
                  </div>
                  <div class="row" *ngIf="dcmotor">
                    <div class="col col-md-6">
                      <label
                        >Type of DC Motor Control<span
                          class="material-icons info"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="dc_type"
                          id="dc_type"
                        >
                          <option value="PEB">Power Electronics based</option>
                          <option value="other">Other</option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Duty<span
                          class="material-icons info"
                          ngbPopover="Duty type/load cycle to which the motor is subjected"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="duty"
                        id="duty"
                      />
                    </div>
                    <div
                      class="col col-md-6"
                      *ngIf="selectedAssetType === 'MOTOR'"
                    >
                      <label> Number Of Pole Pairs </label>
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="polePairNumber"
                          id="polePairNumber"
                        >
                          <option
                            *ngFor="let value of NumberOfPolePairs"
                            [value]="value"
                          >
                            {{ value }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div class="rated_temp" style="margin-bottom: 12px">
                    <mat-radio-group
                      aria-label="select an option"
                      formControlName="bearing_radio"
                      id="bearing_radio"
                    >
                      <mat-radio-button
                        value="on"
                        (change)="bearingButton($event.value, 'OTHER')"
                        >Ball Bearing</mat-radio-button
                      >
                      <mat-radio-button
                        value="off"
                        (change)="bearingButton($event.value, 'OTHER')"
                        >Sleeve Bearing</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >DE Bearing Number<span
                          class="material-icons info"
                          ngbPopover="Drive End Bearing Number which denotes bearing specifications"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="de_bearing_number"
                          id="de_bearing_number"
                        >
                          <option
                            *ngFor="let bearingNum of bearingNumbers"
                          >
                          <!-- <option
                            *ngFor="let bearingNum of bearingNumbers"
                            [selected]="
                              bearingNum.bearing_number === preDeBearingNumber
                            "
                          > -->
                            {{ bearingNum.bearing_number }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >NDE Bearing Number<span
                          class="material-icons info"
                          ngbPopover="Non-Drive End Bearing Number which denotes bearing specifications"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="nde_bearing_number"
                          id="nde_bearing_number"
                        >
                          <option
                            *ngFor="let bearingNum2 of bearingNumbers"
                          >
                            {{ bearingNum2.bearing_number }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-6" style="padding-top: 26px">
                      <button
                        type="button"
                        class="primary_btn"
                        mat-raised-button
                        (click)="addNewBearing()"
                      >
                        Add Bearing Number
                      </button>
                    </div>
                  </div>

                  <hr class="horizontal_line" />
                  <div class="row">
                    <div class="col-sm">
                      <label class="sub_title">Drive Details</label>
                    </div>
                    <div class="col-sm" style="text-align: right">
                      <button
                        type="button"
                        class="primary_btn"
                        mat-raised-button
                        (click)="addNewBeltNumber()"
                      >
                        Add Belt Number
                      </button>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 col">
                      <mat-radio-group
                        [(ngModel)]="driveType"
                        (change)="onDriveChange($event)"
                        [ngModelOptions]="{ standalone: true }"
                      >
                        <mat-radio-button class="r1-btn-margin" value="DIRECT">
                          Direct Drive
                        </mat-radio-button>
                        <mat-radio-button
                          style="margin-left: 16px !important"
                          value="PULLEY"
                        >
                          Pulley Belt Drive
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>

                  <div *ngIf="driveVisibility">
                    <div class="row">
                      <div class="col col-md-6">
                        <label
                          >Driver Pulley Diameter *<span
                            class="material-icons info"
                            ngbPopover="Power in KW or HP the motor was designed to operate at"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <div class="rated_temp">
                          <input
                            type="text"
                            class="form-control"
                            type="number"
                            formControlName="driver_pulley_diameter"
                            id="driver_pulley_diameter"
                          />
                          <label
                            style="
                              font-size: 13px;
                              font-weight: lighter;
                              padding-left: 10px;
                              padding-top: 5px;
                            "
                            >cm</label
                          >
                        </div>
                      </div>
                      <div class="col col-md-6">
                        <label
                          >Driven Pulley Diameter *<span
                            class="material-icons info"
                            ngbPopover="Rated RPM the motor was designed to operate at"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <div class="rated_temp">
                          <input
                            type="text"
                            class="form-control"
                            formControlName="driven_pulley_diameter"
                            id="driven_pulley_diameter"
                          />
                          <label
                            style="
                              font-size: 13px;
                              font-weight: lighter;
                              padding-left: 10px;
                              padding-top: 5px;
                            "
                            >cm</label
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-md-6">
                        <label
                          >Distance Between Shaft Centers *<span
                            class="material-icons info"
                            ngbPopover="Frequency at which the sensor data files are
                              sent from the Enertics device to the Cloud (mins)"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <div class="rated_temp">
                          <input
                            type="text"
                            class="form-control"
                            type="number"
                            formControlName="db_shart_centers"
                            id="db_shart_centers"
                          />
                          <label
                            style="
                              font-size: 13px;
                              font-weight: lighter;
                              padding-left: 10px;
                              padding-top: 5px;
                            "
                            >cm</label
                          >
                        </div>
                      </div>
                      <div class="col col-md-6"></div>
                    </div>
                    <div class="row">
                      <div class="col col-md-4">
                        <label
                          >Belt Number *<span
                            class="material-icons info"
                            ngbPopover="Compensation value for Stator Winding temperature (0 - 5 deg )"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <span class="custom_select_outer">
                          <select
                            class="custom_select form-control"
                            (change)="selectBeltNumber($event.target.value)"
                            formControlName="belt_number"
                            id="belt_number"
                          >
                            <option>Select Belt Number</option>
                            <option
                              *ngFor="let beltInfo of beltData"
                              [value]="beltInfo.belt_number"
                            >
                              {{ beltInfo.belt_number }}
                            </option>
                          </select>
                        </span>
                      </div>
                      <div class="col col-md-4">
                        <label
                          >Belt Length *<span
                            class="material-icons info"
                            ngbPopover="Compensation value for NDE Bearing temperature ( 0 - 5 deg )"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <span class="custom_select_outer">
                          <input
                            type="text"
                            disabled="true"
                            class="form-control"
                            type="number"
                            formControlName="belt_length"
                            id="belt_length"
                          />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    class="row"
                    *ngIf="
                      selectedAssetType === 'FAN_BLOWER' ||
                      selectedAssetType === 'PUMP'
                    "
                  >
                    <div class="col col-md-6">
                      <label
                        >Number of Blades *<span
                          class="material-icons info"
                          ngbPopover="Number of blades"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          type="text"
                          class="form-control"
                          type="number"
                          formControlName="no_of_blades"
                          id="no_of_blades"
                        />
                      </div>
                    </div>
                    <div class="col col-md-6"></div>
                  </div>

                  <hr class="horizontal_line" />
                  <label class="sub_title">Device Configuration </label>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Sensor Summarize Data Frequency (mins)*<span
                          class="material-icons info"
                          ngbPopover="Frequency at which the sensor data files are
                            sent from the Enertics device to the Cloud (mins)"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="data_frequency"
                        id="data_frequency"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="data_frequency"
                        disabled="true"
                        id="data_frequency"
                      />
                      <control-messages
                         class="err-msg"
                        [control]="uForm.controls.data_frequency"
                      ></control-messages>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >ODR Normal<span
                          class="material-icons info"
                          ngbPopover="ODR"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="accelro_odr"
                          id="accelro_odr"
                        >
                          <option
                            *ngFor="let option of options"
                            [value]="option.value"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >ODR High Res<span
                          class="material-icons info"
                          ngbPopover="ODR"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="accelro_odr_high"
                          id="accelro_odr_high"
                        >
                          <option
                            *ngFor="let option of options"
                            [value]="option.value"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >High Res Data Push Rate (mins) *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >

                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_high"
                        id="cloud_pushrate_high"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_high"
                        disabled="true"
                        id="cloud_pushrate_high"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.cloud_pushrate_high"
                      ></control-messages>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >Anomaly Analysis Frequency (mins) *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >

                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_anomaly"
                        id="cloud_pushrate_anomaly"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_anomaly"
                        disabled="true"
                        id="cloud_pushrate_anomaly"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.cloud_pushrate_anomaly"
                      ></control-messages>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >Anomaly Counter*<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_anomaly_counter"
                        id="cloud_anomaly_counter"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_anomaly_counter"
                        disabled="true"
                        id="cloud_anomaly_counter"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.cloud_anomaly_counter"
                      ></control-messages>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >Scan Rate (sec) *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="vs_scan_rate"
                        id="vs_scan_rate"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="vs_scan_rate"
                        disabled="true"
                        id="vs_scan_rate"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.vs_scan_rate"
                      ></control-messages>
                    </div>
                  </div>

                  <div class="row">
                    <button
                    style="width: 175px;margin-left: 14px;"
                    mat-raised-button color="primary"
                      type="button"
                      (click)="AdvanceSettings()"
                    >
                      Advance Setting
                    </button>
                  </div>
                  <div class="row">
                    <div class="col col-md-6" *ngIf="AdvanceSetting">
                      <label
                        >Machine Threshold Status*<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        type="text"
                        class="form-control"
                        formControlName="machine_threshold_status"
                        id="machine_threshold_status"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="machine_threshold_status"
                        disabled="true"
                        id="machine_threshold_status"
                      />
                    </div>
                    <div class="col-md-6" *ngIf="AdvanceSetting">
                      <label
                        >Accelro FS*<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        formControlName="accelero_FS"
                        id="accelero_FS"
                        disabled="true"
                      />
                    </div>
                  </div>
                  <hr class="horizontal_line" />
                  <label class="sub_title">Other Configuration </label>
                  <label class="sub_child_title">Mounting Axis Options</label>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Sensor Mounting Axis Options<span
                          class="material-icons info"
                          ngbPopover="Sensor Mounting Axis Options"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="sensor_mounting_axis_option"
                          id="sensor_mounting_axis_option"
                        >
                          <option value="PARALLEL_SIDE">
                            Parallel to the Machine Shaft (Side)
                          </option>
                          <option value="PARALLEL_TOP">
                            Parallel to the Machine Shaft (Top)
                          </option>
                          <option value="PERPENDICULAR">
                            Perpendicular to Machine Shaft
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <!--Empty col add something here-->
                    </div>
                    <div class="col col-md-4">
                      <!--Empty col add something here-->
                    </div>
                  </div>

                  <label class="sub_title">Acoustics Compensation (dB-A)</label>

                  <div class="row">
                    <div class="col col-md-6">
                      <label> Audible Adjustment </label>
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="audible_adjustment"
                          id="audible_adjustment"
                        >
                          <option
                            *ngFor="let val of audibleSoundList"
                            [value]="val"
                          >
                            {{ val }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <!--
                      <div class="col col-md-6" *ngIf="selectedAssetType === 'MOTOR'">
                        <label>
                          Number Of Pole Pairs
                        </label>
                        <span class="custom_select_outer">
                          <select
                            class="custom_select form-control"
                            formControlName="polePairNumber"
                            id="polePairNumber"
                          >
                          <option *ngFor="let value of NumberOfPolePairs" [value]="value">{{value}}</option>
                          </select>
                        </span>
                      </div> -->
                  </div>
                  <label class="sub_child_title"
                    >Temperature Sensor Location</label
                  >
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >RTD1<span
                          class="material-icons info"
                          ngbPopover="RTD1"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="rtd_one"
                          id="rtd_one"
                        >
                          <option value="MS">Machine Skin</option>
                          <option value="DE">DE Bearing</option>
                          <option value="NDE">NDE Bearing</option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >RTD2<span
                          class="material-icons info"
                          ngbPopover="RTD2"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="rtd_two"
                          id="rtd_two"
                        >
                          <option value="MS">Machine Skin</option>
                          <option value="DE">DE Bearing</option>
                          <option value="NDE">NDE Bearing</option>
                          <option value="NA">NA</option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >RTD3<span
                          class="material-icons info"
                          ngbPopover="RTD3"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="rtd_three"
                          id="rtd_three"
                        >
                          <option value="MS">Machine Skin</option>
                          <option value="DE">DE Bearing</option>
                          <option value="NDE">NDE Bearing</option>
                          <option value="NA">NA</option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <label class="sub_child_title"
                    >Temperature Compensation (°C)</label
                  >
                  <div class="row">
                    <div class="col col-md-4">
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="de_bearing"
                          id="de_bearing"
                        >
                          <option
                            *ngFor="let temp_v of tempValuesArr"
                            [value]="temp_v"
                          >
                            {{ temp_v }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="winding_rtd"
                          id="winding_rtd"
                        >
                          <option
                            *ngFor="let temp_v of tempValuesArr"
                            [value]="temp_v"
                          >
                            {{ temp_v }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="nde_bearing"
                          id="nde_bearing"
                        >
                          <option
                            *ngFor="let temp_v of tempValuesArr"
                            [value]="temp_v"
                          >
                            {{ temp_v }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <label class="sub_child_title">Vibration compensation</label>

                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Radial (Horizontal)<span
                          class="material-icons info"
                          ngbPopover="Horizontal"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <input
                          id="Vertical"
                          type="number"
                          formControlName="Vertical"
                          disabled="true"
                        />
                        <!-- <Button id="incrementButtonver" type="button" class="countBtn" (click)="increment('Vertical')">+</Button>
                        <Button  id="DecrementButtonver" type="button" class="countBtn"  (click)="decrement('Vertical')">-</Button> -->
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >Tangential (Vertical)<span
                          class="material-icons info"
                          ngbPopover="Vertical"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <input
                          id="Horizontal"
                          type="number"
                          formControlName="Horizontal"
                          disabled="true"
                        />
                        <!-- <Button id="incrementButtonhor" type="button" class="countBtn"  (click)="increment('Horizontal')">+</Button>
                        <Button  id="DecrementButtonhor" type="button" class="countBtn"  (click)="decrement('Horizontal')">-</Button> -->
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >Axial<span
                          class="material-icons info"
                          ngbPopover="Axial"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <input
                          id="Axial"
                          type="number"
                          formControlName="Axial"
                          disabled="true"
                        />
                        <!-- <Button id="incrementButton" type="button" class="countBtn"  (click)="increment('Axial')">+</Button>
                        <Button  id="DecrementButton" type="button" class="countBtn"  (click)="decrement('Axial')">-</Button> -->
                      </span>
                    </div>
                  </div>

                  <div *ngIf="showEditUsertxt === 'Edit Asset'">
                    <!-- Show last calibration date -->
                    <div *ngIf="lastCalibrationDate">
                      Last Calibrated: {{ lastCalibrationDate }}
                    </div>

                    <!-- Default message if no calibration -->
                    <div *ngIf="!lastCalibrationDate">
                      No calibration data found
                    </div>

                    <div class="btnRowWrap">
                      <button
                        type="button"
                        class="primary_btn red-btn"
                        mat-raised-button
                        (click)="resetValues()"
                      >
                        Reset Values
                      </button>
                      <Button
                        type="button"
                        class="primary_btn"
                        mat-raised-button
                        (click)="calibratepopup()"
                        >Calibrate</Button
                      >
                    </div>
                  </div>

                  <hr class="horizontal_line" />
                  <label class="sub_title">Connectivity Configuration </label>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Connectivity Type<span
                          class="material-icons info"
                          ngbPopover="Connectivity Type"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="connectivity_type"
                          id="connectivity_type"
                          (change)="selectConnectionType($event.target.value)"
                        >
                          <option value="wifi">Wifi</option>
                        </select>
                      </span>
                    </div>

                    <div class="col col-md-4" *ngIf="connectionInput">
                      <label
                        >WiFi SSID*<span
                          class="material-icons info"
                          ngbPopover="WiFi SSID"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >

                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        type="text"
                        class="form-control"
                        formControlName="wifi_user"
                        id="wifi_user"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        type="text"
                        class="form-control"
                        formControlName="wifi_user"
                        disabled="true"
                        id="wifi_user"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.wifi_user"
                      ></control-messages>
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInput">
                      <label
                        >WiFi Password<span
                          class="material-icons info"
                          ngbPopover="WiFi Password"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        [type]="isTextFieldType ? 'text' : 'password'"
                        class="form-control"
                        formControlName="wifi_password"
                        id="wifi_password"
                        readonly
                        onfocus="if (this.hasAttribute('readonly')) { this.removeAttribute('readonly');
                            this.blur();    this.focus();  }"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        [type]="isTextFieldType ? 'text' : 'password'"
                        class="form-control"
                        formControlName="wifi_password"
                        disabled="true"
                        id="wifi_password"
                        autocomplete="false"
                      />
                      <mat-icon
                        class="eye_c"
                        *ngIf="isTextFieldType === true"
                        (click)="togglemyPasswordFieldType()"
                      >
                        visibility</mat-icon
                      >
                      <mat-icon
                        class="eye_c"
                        *ngIf="isTextFieldType === false"
                        (click)="togglemyPasswordFieldType()"
                      >
                        visibility_off</mat-icon
                      >
                    </div>

                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >IP *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="ip"
                        id="ip"
                      />
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >Port *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="port"
                        id="port"
                      />
                    </div>

                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >Username<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="proxy_username"
                        id="proxy_username"
                      />
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >Password<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="password"
                        class="form-control"
                        formControlName="proxy_password"
                        id="proxy_password"
                      />
                    </div>
                  </div>
                  <!-- <p>Threshold template</p> -->

                  <hr class="horizontal_line" />
                  <div class="form_actions text-right">
                    <span>
                      <button
                        *ngIf="!showSavebtn"
                        class="primary_btn"
                        mat-raised-button
                        type="button"
                        [disabled]="!uForm.valid"
                        (click)="saveDraft()"
                      >
                        Continue
                      </button>
                    </span>
                    <span *ngIf="showSavebtn">
                      <button
                        *ngIf="showSavebtn"
                        class="primary_btn"
                        mat-raised-button
                        type="submit"
                        [disabled]="!uForm.valid"
                      >
                        Create Asset
                      </button>
                    </span>
                    <!-- <button
                      *ngIf="showUpdateBtn"
                      class="primary_btn"
                      mat-raised-button
                      type="submit"
                      [disabled]="!(uForm.valid && uForm.dirty)"
                    >
                      Update Asset
                    </button> -->
                    <button
                      class="default_btn"
                      mat-raised-button
                      type="button"
                      (click)="cancelButtonPress()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
              <div *ngIf="gearDetailForm">
                <form [formGroup]="uForm" (ngSubmit)="saveAsstes()">
                  <h4>
                    <button
                      [disabled]="true"
                      [style.background-color]="
                        currentLbl === 1 ? '#FFB3B3' : '#C4DFAA'
                      "
                    >
                      {{
                        showEditUsertxt ==
                        "Edit
                        Asset"
                          ? device_sno
                          : currentSensorIndex == 0
                          ? "B"
                          : currentSensorIndex
                      }}
                    </button>
                    {{selectedAssetType}} Asset Details
                  </h4>
                  <div class="row">
                    <div class="col-md-6 col">
                      <label
                        >Asset Name *<span
                          class="material-icons info"
                          ngbPopover="Asset Name, given by the Client, e.g. Mixer Motor 1"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="name"
                        id="name"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.name"
                      ></control-messages>
                    </div>
                    <div class="col-md-6 col">
                      <label
                        >Site *<span
                          class="material-icons info"
                          ngbPopover="Client Site, e.g. Hamilton Site"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="showEditUsertxt == 'Edit Asset'"
                        type="text"
                        class="form-control"
                        formControlName="site_id_val"
                        id="site_id_val"
                      />
                      <span
                        class="custom_select_outer"
                        *ngIf="showEditUsertxt == 'Create Asset' || 'Update Powertrain'"
                      >
                        <select
                          class="custom_select form-control"
                          formControlName="site_id"
                          id="site_id"
                          (change)="selectSite($event.target.value)"
                        >
                          <option value="all"></option>
                          <option
                            [value]="site.id"
                            *ngFor="let site of sitesList"
                          >
                            {{ site.name }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Application *<span
                          class="material-icons info"
                          ngbPopover="Name of the Application, given by the Client, e.g. Scrubber Application"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="showEditUsertxt == 'Edit Asset'"
                        type="text"
                        class="form-control"
                        formControlName="application_id_name"
                        id="application_id_name"
                      />
                      <span
                        class="custom_select_outer"
                        *ngIf="showEditUsertxt == 'Create Asset' || 'Update Powertrain'"
                      >
                        <select
                          id="application_id"
                          class="custom_select form-control"
                          formControlName="application_id"
                        >
                          <option
                            *ngFor="
                              let application of applications;
                              let idx = index
                            "
                            [ngValue]="application.id"
                          >
                            {{ application.name }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-6"></div>
                  </div>

                  <hr class="horizontal_line" />
                  <div class="row">
                    <div class="col-md-6 col">
                      <label
                        >1Ph Line Current<span
                          class="material-icons info"
                          ngbPopover="1Ph Line Current"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="line_current"
                        id="line_current"
                      />
                    </div>
                    <div class="col-md-6 col">
                      <label
                        >Device Name *<span
                          class="material-icons info"
                          ngbPopover="Device identifiers"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="device_name"
                        id="device_name"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.device_name"
                      ></control-messages>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Device ID *<span
                          class="material-icons info"
                          ngbPopover="Enertics Device Serial Number"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <input
                          class="form-control"
                          type="text"
                          formControlName="mac_address"
                          id="mac_address"
                          (input)="filterUsers($event.target.value)"
                          [matAutocomplete]="auto4"
                        />
                        <control-messages
                          class="err-msg"
                          [control]="uForm.controls.mac_address"
                        ></control-messages>
                        <mat-autocomplete
                          autoActiveFirstOption
                          #auto4="matAutocomplete"
                          (optionSelected)="
                            onFilterOptionSelected($event.option.value)
                          "
                        >
                          <mat-option
                            *ngFor="let option of filterdOptions"
                            [value]="option.mac_address"
                            (click)="selectedOption()"
                          >
                            {{ option.mac_address }}
                          </mat-option>
                        </mat-autocomplete>
                      </span>
                      <p
                        style="
                          font-size: 12px;
                          color: #b10000;
                          margin-bottom: 0px;
                          margin-top: 0px;
                        "
                        *ngIf="ivInventoryMsg != ''"
                      >
                        {{ ivInventoryMsg }}
                      </p>
                    </div>

                    <div class="col col-md-6">
                      <label
                        >Gear Box Make<span
                          class="material-icons info"
                          ngbPopover="Manufacturer of the Gear"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="gear_make"
                        id="gear_make"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label>Equipment Location</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="equipment_location"
                        id="equipment_location"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Frame<span
                          class="material-icons info"
                          ngbPopover="The Frame Size of motor according to NEMA standard"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="frame"
                        id="frame"
                      />
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Rated Ambient Temperature<span
                          class="material-icons info"
                          ngbPopover="Maximum ambient temperature motor is designed to operate at, typically 40C"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          class="form-control"
                          type="number"
                          formControlName="rated_ambient_temprature"
                          id="rated_ambient_temprature"
                        />
                        <mat-radio-group
                          formControlName="temperature_sy"
                          id="temperature_sy"
                        >
                          <mat-radio-button value="C"> ̊C</mat-radio-button>
                          <mat-radio-button value="F">F</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Rated Power *<span
                          class="material-icons info"
                          ngbPopover="Power in KW or HP the motor was designed to operate at"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <div class="rated_temp">
                        <input
                          type="text"
                          class="form-control"
                          type="number"
                          formControlName="rated_power"
                          id="rated_power"
                        />
                        <control-messages
                          class="err-msg"
                          [control]="uForm.controls.rated_power"
                        ></control-messages>
                        <mat-radio-group
                          aria-label="Select an option"
                          formControlName="power_unit"
                          id="power_unit"
                        >
                          <mat-radio-button value="KW">KW</mat-radio-button>
                          <mat-radio-button value="fi">HP</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >Serial Number *<span
                          class="material-icons info"
                          ngbPopover="Serial Number on the Motor nameplate"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="motor_serial"
                        id="motor_serial"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.motor_serial"
                      ></control-messages>
                    </div>
                  </div>
                  <hr class="horizontal_line" />

                  <div class="row">
                    <div class="col-sm">
                      <label class="sub_title"> Pinion Gear Details</label>
                    </div>
                    <div class="col-sm" style="text-align: right">
                      <button
                        type="button"
                        class="primary_btn"
                        mat-raised-button
                        (click)="addNewBearing()"
                      >
                        Add Bearing Number
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Pinion Gear RPM *<span
                          class="material-icons info"
                          ngbPopover="Max Volatage the motor was designed to operate at"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="pinion_gear_rpm"
                        id="pinion_gear_rpm"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.pinion_gear_rpm"
                      ></control-messages>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >No. of teeth for Pinion Gear<span
                          class="material-icons info"
                          ngbPopover="Pinion Gear Teeth"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="pinion_gear_teeth"
                        id="pinion_gear_teeth"
                      />
                    </div>
                  </div>
                  <div class="rated_temp" style="margin-bottom: 12px">
                    <mat-radio-group
                      aria-label="select an option"
                      formControlName="bearing_radio"
                      id="bearing_radio"
                    >
                      <mat-radio-button
                        value="on"
                        (change)="bearingButton($event.value, 'GEAR')"
                        >Ball Bearing</mat-radio-button
                      >
                      <mat-radio-button
                        value="off"
                        (change)="bearingButton($event.value, 'GEAR')"
                        >Sleeve Bearing</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >DE Pinion Bearings Number *<span
                          class="material-icons info"
                          ngbPopover="Pinion Bearing Number which denotes bearing specifications"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="deb_pinion_number"
                          id="deb_pinion_number"
                        >
                          <option
                            *ngFor="let bearingNum of bearingNumbers"
                            [value]="bearingNum.bearing_number"
                          >
                            {{ bearingNum.bearing_number }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >NDE Pinion Bearings Number *<span
                          class="material-icons info"
                          ngbPopover="Pinion Bearing Number which denotes bearing specifications"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="ndeb_pinion_number"
                          id="ndeb_pinion_number"
                        >
                          <option
                            *ngFor="let bearingNum of bearingNumbers"
                            [value]="bearingNum.bearing_number"
                          >
                            {{ bearingNum.bearing_number }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <hr class="horizontal_line" />
                  <label class="sub_title">Output Gear Details</label>
                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >Output Gear RPM *<span
                          class="material-icons info"
                          ngbPopover="Max Volatage the motor was designed to operate at"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="outer_gear_rpm"
                        id="outer_gear_rpm"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.outer_gear_rpm"
                      ></control-messages>
                    </div>
                    <div class="col col-md-6">
                      <label
                        >No. of teeth for Output Gear<span
                          class="material-icons info"
                          ngbPopover="Pinion Gear Teeth"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="outer_teeth"
                        id="outer_teeth"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-md-6">
                      <label
                        >No. of Output Gears *<span
                          class="material-icons info"
                          ngbPopover="Name of the Gear, given by the Client, e.g. Scrubber Application"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          (change)="selectNumberOfGear($event.target.value)"
                          formControlName="gear_count"
                          id="gear_count"
                        >
                          <option value="0">No. of Output Gears</option>
                          <option value="1" selected>1</option>
                          <!-- <option value="2">2</option>
                            <option value="3">3</option> -->
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-6"></div>
                  </div>
                  <div class="rated_temp" style="margin-bottom: 12px">
                    <mat-radio-group
                      aria-label="select an option"
                      formControlName="output_bearing_radio"
                      id="output_bearing_radio"
                    >
                      <mat-radio-button
                        value="yes"
                        (change)="outputBearingButton($event.value)"
                        >Ball Bearing</mat-radio-button
                      >
                      <mat-radio-button
                        value="no"
                        (change)="outputBearingButton($event.value)"
                        >Sleeve Bearing</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                  <div formArrayName="outer_bearing_no">
                    <div
                      class="row"
                      *ngFor="
                        let outer_bearing_no of outer_bearing_no().controls;
                        let i = index
                      "
                      [formGroupName]="i"
                    >
                      <div class="col col-md-5">
                        <label
                          >[{{ i + 1 }}] DE Output Bearing Number *<span
                            class="material-icons info"
                            ngbPopover="Outer Bearing Number which denotes bearing specifications"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <span class="custom_select_outer">
                          <select
                            class="custom_select form-control"
                            formControlName="ndeb_outer"
                            id="ndeb_outer"
                          >
                            <option
                              *ngFor="let bearingNum of bearingNumbers"
                              [value]="bearingNum.bearing_number"
                            >
                              {{ bearingNum.bearing_number }}
                            </option>
                          </select>
                        </span>
                      </div>
                      <div class="col col-md-5">
                        <label
                          >[{{ i + 1 }}] NDE Output Bearing Number *<span
                            class="material-icons info"
                            ngbPopover="Outer Bearing Number which denotes bearing specifications"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <span class="custom_select_outer">
                          <select
                            class="custom_select form-control"
                            formControlName="deb_outer"
                            id="deb_outer"
                          >
                            <option
                              *ngFor="let bearingNum of bearingNumbers"
                              [value]="bearingNum.bearing_number"
                            >
                              {{ bearingNum.bearing_number }}
                            </option>
                          </select>
                        </span>
                      </div>
                      <div class="col col-md-2">
                        <span class="custom_select_outer">
                          <p
                            *ngIf="i > 0"
                            style="
                              cursor: pointer;
                              margin-top: 30px;
                              font-size: 14px;
                              color: #0065bf;
                            "
                            (click)="removeFileds(i)"
                          >
                            Remove
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <hr class="horizontal_line" />
                  <!-- <h2>GMF frequencies for GearBox</h2> -->
                  <label class="sub_title">Gear Mesh Frequency (GMF)</label>
                  <div class="row">
                    <div class="col col-md-6">
                      <div class="rated_temp">
                        <label>Do you know Gear Mesh Frequency (GMF)?</label>
                        <mat-radio-group
                          aria-label="Select an option"
                          formControlName="GMF_unit"
                          id="GMF_unit"
                        >
                          <mat-radio-button
                            value="yes"
                            (change)="selectGMF($event.value)"
                            >Yes</mat-radio-button
                          >
                          <mat-radio-button
                            value="no"
                            (change)="selectGMF($event.value)"
                            >No</mat-radio-button
                          >
                        </mat-radio-group>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="GMFvisible" id="numGMF">
                    <div class="col col-md-6">
                      <label
                        >No. of GMF *<span
                          class="material-icons info"
                          ngbPopover="Name of the Gear, given by the Client, e.g. Scrubber Application"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="GMFdrop"
                          id="GMFdrop"
                          (change)="selectNumberOfGMF($event.target.value)"
                        >
                          <option value="0">Select No. of GMF</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <div formArrayName="gmf_data">
                    <div
                      class="row"
                      *ngFor="
                        let gmf_data of gmf_data().controls;
                        let i = index
                      "
                      [formGroupName]="i"
                    >
                      <div class="col col-md-5">
                        <label
                          >GMF [{{ i + 1 }}] *<span
                            class="material-icons info"
                            ngbPopover="GMF name which denotes Gear Mesh Frequency"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="gmfName"
                          id="gmfName"
                        />
                      </div>
                      <div class="col col-md-5">
                        <label
                          >Number For GMF [{{ i + 1 }}]*<span
                            class="material-icons info"
                            ngbPopover="GMF Number which denotes Gear Mesh Frequency"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="gmfNumber"
                          id="gmfNumber"
                        />
                      </div>
                      <div class="col col-md-2">
                        <span class="custom_select_outer">
                          <p
                            *ngIf="i >= 0"
                            style="
                              cursor: pointer;
                              margin-top: 30px;
                              font-size: 14px;
                              color: #0065bf;
                            "
                            (click)="removeFileds(i, 'gmf')"
                          >
                            Remove
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- <h3>end</h3> -->
                  <hr class="horizontal_line" />
                  <label class="sub_title">Device Configuration</label>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Sensor Summarize Data Frequency (mins) *<span
                          class="material-icons info"
                          ngbPopover="Frequency at which the sensor data files are
                            sent from the Enertics device to the Cloud (mins)"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >

                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="data_frequency"
                        id="data_frequency"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="data_frequency"
                        disabled="true"
                        id="data_frequency"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.data_frequency"
                      ></control-messages>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >ODR Normal<span
                          class="material-icons info"
                          ngbPopover="ODR"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="accelro_odr"
                          id="accelro_odr"
                        >
                          <option
                            *ngFor="let option of options"
                            [value]="option.value"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >ODR High Res<span
                          class="material-icons info"
                          ngbPopover="ODR"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="accelro_odr_high"
                          id="accelro_odr_high"
                        >
                          <option
                            *ngFor="let option of options"
                            [value]="option.value"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >High Res Data Push Rate (mins) *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >

                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_high"
                        id="cloud_pushrate_high"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_high"
                        disabled="true"
                        id="cloud_pushrate_high"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.cloud_pushrate_high"
                      ></control-messages>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >Anomaly Analysis Frequency (mins) *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >

                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_anomaly"
                        id="cloud_pushrate_anomaly"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_pushrate_anomaly"
                        disabled="true"
                        id="cloud_pushrate_anomaly"
                      />
                    </div>
                    <control-messages
                      class="err-msg"
                      [control]="uForm.controls.cloud_pushrate_anomaly"
                    ></control-messages>
                    <div class="col col-md-4">
                      <label>
                        Anomaly Counter *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_anomaly_counter"
                        id="cloud_anomaly_counter"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="cloud_anomaly_counter"
                        disabled="true"
                        id="cloud_anomaly_counter"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.cloud_anomaly_counter"
                      ></control-messages>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Scan Rate (sec) *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="vs_scan_rate"
                        id="vs_scan_rate"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="vs_scan_rate"
                        disabled="true"
                        id="vs_scan_rate"
                      />
                      <control-messages
                        class="err-msg"
                        [control]="uForm.controls.vs_scan_rate"
                      ></control-messages>
                    </div>
                  </div>

                  <div class="row">
                    <button
                    style="width: 175px;margin-left: 14px;"
                    mat-raised-button color="primary"
                      type="button"
                      (click)="AdvanceSettings()"
                    >
                      Advance Setting
                    </button>
                  </div>
                  <div class="row">
                    <div class="col col-md-6" *ngIf="AdvanceSetting">
                      <label
                        >Machine Threshold Status*<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        type="text"
                        class="form-control"
                        formControlName="machine_threshold_status"
                        id="machine_threshold_status"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        (keyup)="onKey($event)"
                        type="number"
                        class="form-control"
                        formControlName="machine_threshold_status"
                        disabled="true"
                        id="machine_threshold_status"
                      />
                    </div>
                    <div class="col-md-6" *ngIf="AdvanceSetting">
                      <label
                        >Accelro FS*<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        formControlName="accelero_FS"
                        id="accelero_FS"
                        disabled="true"
                      />
                    </div>
                  </div>
                  <hr class="horizontal_line" />
                  <label class="sub_title">Other Configuration </label>
                  <label class="sub_child_title">Mounting Axis Options</label>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Sensor Mounting Axis Options<span
                          class="material-icons info"
                          ngbPopover="Sensor Mounting Axis Options"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="sensor_mounting_axis_option"
                          id="sensor_mounting_axis_option"
                        >
                          <option value="PARALLEL_SIDE">
                            Parallel to the Machine Shaft (Side)
                          </option>
                          <option value="PARALLEL_TOP">
                            Parallel to the Machine Shaft (Top)
                          </option>
                          <option value="PERPENDICULAR">
                            Perpendicular to Machine Shaft
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <!--Empty col add something here-->
                    </div>
                    <div class="col col-md-4">
                      <!--Empty col add something here-->
                    </div>
                  </div>
                  <label class="sub_title">Acoustics Compensation (dB-A)</label>

                  <div class="row">
                    <div class="col col-md-6">
                      <label> Audible Adjustment </label>
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="audible_adjustment"
                          id="audible_adjustment"
                        >
                          <option
                            *ngFor="let val of audibleSoundList"
                            [value]="val"
                          >
                            {{ val }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <label class="sub_child_title"
                    >Temperature Sensor Location</label
                  >
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >RTD1<span
                          class="material-icons info"
                          ngbPopover="RTD1"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="rtd_one"
                          id="rtd_one"
                        >
                          <option value="MS">Machine Skin</option>
                          <option value="DE">DE Bearing</option>
                          <option value="NDE">NDE Bearing</option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >RTD2<span
                          class="material-icons info"
                          ngbPopover="RTD2"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="rtd_two"
                          id="rtd_two"
                        >
                          <option value="MS">Machine Skin</option>
                          <option value="DE">DE Bearing</option>
                          <option value="NDE">NDE Bearing</option>
                          <option value="NA">NA</option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <label
                        >RTD3<span
                          class="material-icons info"
                          ngbPopover="RTD3"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="rtd_three"
                          id="rtd_three"
                        >
                          <option value="MS">Machine Skin</option>
                          <option value="DE">DE Bearing</option>
                          <option value="NDE">NDE Bearing</option>
                          <option value="NA">NA</option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <label class="sub_child_title"
                    >Temperature Compensation (°C)</label
                  >
                  <div class="row">
                    <div class="col col-md-4">
                      <span class="custom_select_outer">
                        <select
                          id="de_bearing"
                          class="custom_select form-control"
                          formControlName="de_bearing"
                          id="de_bearing"
                        >
                          <option
                            *ngFor="let temp_v of tempValuesArr"
                            [value]="temp_v"
                          >
                            {{ temp_v }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="winding_rtd"
                          id="winding_rtd"
                        >
                          <option
                            *ngFor="let temp_v of tempValuesArr"
                            [value]="temp_v"
                          >
                            {{ temp_v }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4">
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="nde_bearing"
                          id="nde_bearing"
                        >
                          <option
                            *ngFor="let temp_v of tempValuesArr"
                            [value]="temp_v"
                          >
                            {{ temp_v }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <hr class="horizontal_line" />
                  <label class="sub_title">Connectivity Configuration</label>
                  <div class="row">
                    <div class="col col-md-4">
                      <label
                        >Connectivity Type<span
                          class="material-icons info"
                          ngbPopover="Connectivity Type"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <span class="custom_select_outer">
                        <select
                          class="custom_select form-control"
                          formControlName="connectivity_type"
                          id="connectivity_type"
                          (change)="selectConnectionType($event.target.value)"
                        >
                          <option value="wifi">Wifi</option>
                        </select>
                      </span>
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInput">
                      <label
                        >WiFi SSID<span
                          class="material-icons info"
                          ngbPopover="WiFi SSID"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        type="text"
                        class="form-control"
                        formControlName="wifi_user"
                        id="wifi_user"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        type="text"
                        class="form-control"
                        formControlName="wifi_user"
                        disabled="true"
                        id="wifi_user"
                      />
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInput">
                      <label
                        >WiFi Password<span
                          class="material-icons info"
                          ngbPopover="WiFi Password"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        *ngIf="assetStatus === 1 || assetStatus === 0"
                        [type]="isTextFieldType ? 'text' : 'password'"
                        class="form-control"
                        formControlName="wifi_password"
                        id="wifi_password"
                        readonly
                        onfocus="if (this.hasAttribute('readonly')) { this.removeAttribute('readonly');
                          this.blur();    this.focus();  }"
                      />
                      <input
                        *ngIf="assetStatus === 2"
                        [type]="isTextFieldType ? 'text' : 'password'"
                        class="form-control"
                        formControlName="wifi_password"
                        disabled="true"
                        id="wifi_password"
                        autocomplete="false"
                      />
                      <span class="p-viewer">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </span>
                      <mat-icon
                        class="eye_c"
                        *ngIf="isTextFieldType === true"
                        (click)="togglemyPasswordFieldType()"
                      >
                        visibility</mat-icon
                      >
                      <mat-icon
                        class="eye_c"
                        *ngIf="isTextFieldType === false"
                        (click)="togglemyPasswordFieldType()"
                      >
                        visibility_off</mat-icon
                      >
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >IP *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="ip"
                        id="ip"
                      />
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >Port *<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="port"
                        id="port"
                      />
                    </div>

                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >Username<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        formControlName="proxy_username"
                        id="proxy_username"
                      />
                    </div>
                    <div class="col col-md-4" *ngIf="connectionInputProxy">
                      <label
                        >Password<span
                          class="material-icons info"
                          ngbPopover=""
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label
                      >
                      <input
                        type="password"
                        class="form-control"
                        formControlName="proxy_password"
                        id="proxy_password"
                      />
                    </div>
                  </div>

                  <hr class="horizontal_line" />

                  <div class="form_actions text-right">
                    <span *ngIf="!showSavebtn">
                      <button
                        class="primary_btn"
                        mat-raised-button
                        type="button"
                        [disabled]="!uForm.valid"
                        (click)="saveDraft()"
                      >
                        Continue
                      </button>
                    </span>

                    <span *ngIf="showSavebtn">
                      <button
                        class="primary_btn"
                        mat-raised-button
                        type="submit"
                        [disabled]="!uForm.valid"
                      >
                        Create Asset
                      </button>
                    </span>

                    <!-- <button
                      *ngIf="showUpdateBtn"
                      class="primary_btn"
                      mat-raised-button
                      type="submit"
                      [disabled]="!(uForm.valid && uForm.dirty)"
                    >
                      Update Asset
                    </button> -->
                    <button
                      class="default_btn"
                      mat-raised-button
                      type="button"
                      (click)="cancelButtonPress()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
